module.exports = __webpack_public_path__ + "img/wa3.efd00998.jpg";